import { useEffect, type ReactNode } from 'react';
import { ThemeContext, DARK_ONLY_VALUE } from './ThemeContext';

// Split out of ThemeContext.tsx (react-refresh/only-export-components) —
// same rationale as AuthProvider.tsx: `useTheme` is imported widely, this
// Provider has one production call site (main.tsx). Behavior unchanged.
export function ThemeProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    // Stamp the attribute for any CSS/tests keying on it; clear the persisted
    // preference so a stale "light" value can never resurface.
    document.documentElement.setAttribute('data-theme', 'dark');
    try {
      localStorage.removeItem('sportform_theme');
    } catch {
      // localStorage may not be available
    }
  }, []);

  return (
    <ThemeContext.Provider value={DARK_ONLY_VALUE}>
      {children}
    </ThemeContext.Provider>
  );
}
